/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/display-name */
import classNames from 'clsx';
import styles from '../../embed.style';
import type { EmbedADT, EmbedProps } from '../../type';

export function twitter(input: EmbedADT) {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host !== 'x.com' && host !== 'twitter.com') return input;

  // https://x.com/blackanger/status/1811057482112135395
  // https://platform.twitter.com/embed/Tweet.html?dnt=true&embedId=twitter-widget-0&features=e30%3D&frame=false&hideCard=false&hideThread=false&id=1811057482112135395&lang=en&origin=notion%3A%2F%2Fwww.notion.so%2Freamd7%2Fc24ebe08084a42789f19b191af2b5220%3Fpvs%3D13&siteScreenName=NotionHQ&theme=light&widgetsVersion=2b959255e8896%3A1673658205745&width=100%25

  const pathname = input.pathname;
  const res = pathname.split('/');
  if (res.length < 4) return input;

  const id = res[3];

  const embedUrl = new URL(
    `https://platform.twitter.com/embed/Tweet.html?dnt=true&embedId=twitter-widget-0&features=e30%3D&frame=false&hideCard=false&hideThread=false&lang=en&siteScreenName=NotionHQ&theme=light&widgetsVersion=2b959255e8896%3A1673658205745&width=100%25`,
  );
  embedUrl.searchParams.set('id', id as string);

  const href = embedUrl.href;
  return (props: EmbedProps) => {
    const { width = '', height = '' } = props;

    const children = (
      <div className={classNames('h-full w-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          src={href}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
        />
      </div>
    );
    return (
      <div
        className={'w-full'}
        style={
          {
            width: width || undefined,
            '--app-markdown-video-ratio': height ? height : '320px',
          } as any
        }
        data-first={props['data-first']}
        data-last={props['data-last']}
      >
        {children}
      </div>
    );
  };
}
